import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookPaymentCartResponse } from '../../responses/platform/book-payment-cart.response';
import { BookPaymentServiceRequest } from '../../requests/platform/book-payment-service.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class BookPaymentServiceService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getByBookVersion(idBookVersion: number): Observable<BookPaymentCartResponse> {
    return this.http
      .get<BookPaymentCartResponse>(
        environment.urlApiPlatform + "BookPaymentService/idBookVersion/" + idBookVersion,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

   public post(request: BookPaymentServiceRequest): Observable<ReturnStruct> {
    return this.http
      .post<ReturnStruct>(
        environment.urlApiPlatform + "BookPaymentService",
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public addServiceToCart(idBookVersion: number, idBookServiceSell: number): Observable<ReturnStruct> {
    return this.http
      .get<ReturnStruct>(
        environment.urlApiPlatform +
          `BookPaymentService/addService/idBookVersion/${idBookVersion}/idBookServiceSell/${idBookServiceSell}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public removeServiceFromCart(idBookVersion: number, idBookServiceSell: number): Observable<ReturnStruct> {
    return this.http
      .get<ReturnStruct>(
        environment.urlApiPlatform +
          `BookPaymentService/removeService/idBookVersion/${idBookVersion}/idBookServiceSell/${idBookServiceSell}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

}
